import * as React from 'react';

import { getEntityFromProfile, getInstagramChannelEntity } from 'utils/view';

import Entity from 'components/entity/Entity';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import EntityName from 'components/entity/entity-name/EntityName';
import MetricsChannelsBasicChannelsHOC from 'components/metrics/channels-basic/MetricsChannelsBasicChannelsHOC';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import type { Channels, ImageSize, InfluencerProfile, InfluencerTile, SubcampaignInfluencerProfile } from 'types';

import './influencer-entity.scss';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import { __t } from 'utils/language';

type Props = {
  influencerProfile: Partial<InfluencerTile> | Partial<SubcampaignInfluencerProfile> | Partial<InfluencerProfile>,
  customSize?: ImageSize,
  preferInstagramDetails?: boolean,
  showFullName?: boolean,
  showAgency?: boolean
};

const InfluencerEntity = (
  {
    influencerProfile,
    customSize,
    preferInstagramDetails,
    showFullName,
    showAgency
  }: Props
): JSX.Element => {
  const nameEntity = getEntityFromProfile(influencerProfile);
  const instagramChannelEntity = getInstagramChannelEntity(influencerProfile);
  const realName = `${nameEntity?.firstName || ''} ${nameEntity?.lastName || ''}`.trim();
  // @ts-ignore - Because Flow is complaining about Optional Chaining for Union Type
  const agencyName = influencerProfile.agencyDetails?.name;

  return (
    <div>
      <Entity>
        <EntityAvatar
          bordered
          entity={nameEntity}
          link={preferInstagramDetails ? instagramChannelEntity.url : nameEntity?.url}
          size="big"
          customSize={customSize}
          openInNewTab
        />
        <div className="influencer-entity__info">
          <div className="influencer-entity__info-name">
            {
              preferInstagramDetails ?
                <EntityName
                  entity={instagramChannelEntity}
                  link={instagramChannelEntity.url}
                  size="inherit"
                  openInNewTab
                /> :
                <EntityName
                  entity={nameEntity}
                  link={nameEntity?.url}
                  size="inherit"
                  openInNewTab
                />
            }
          </div>
          <VerticalSpacing type="tiny" />
          <MetricsChannelsBasicChannelsHOC
            channels={(influencerProfile.channels ?? {}) as Channels}
            showChannels={['instagram', 'tiktok', 'youtube']}
            layout="inline"
            type="limited"
            includeRatio
          />
        </div>
      </Entity>
      {showFullName && realName && realName !== nameEntity?.displayName && (
        <div className="influencer-entity__info-real-name text-overflow-ellipsis">
          {realName}
        </div>
      )}
      {showAgency && agencyName && (
        <div className="influencer-entity__info-agency">
          <div className="influencer-entity__agency-icon">
            <SVGDynamicIcon
              name="agency-building-custom-fg"
              width={16}
              height={16}
              customColor="grey"
            />
          </div>
          <div
            className="creator-tile-agency__label text-overflow-ellipsis"
            title={`${__t('.labels.agency')}: ${agencyName}`}
            data-qa="creator-tile-agency__label"
          >
            {agencyName}
          </div>
        </div>
      )}
    </div>
  );
};

export default InfluencerEntity;
